/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioEarningsBreakdown
 */
export interface PortfolioEarningsBreakdown {
    /**
     * 
     * @type {number}
     * @memberof PortfolioEarningsBreakdown
     */
    loyaltyPointsEarned?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioEarningsBreakdown
     */
    loyaltyPointsCashValue?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioEarningsBreakdown
     */
    gondolaCashEarned?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioEarningsBreakdown
     */
    creditCardPointsEarned?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioEarningsBreakdown
     */
    creditCardName?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioEarningsBreakdown
     */
    totalEarningsUsd?: number;
}

/**
 * Check if a given object implements the PortfolioEarningsBreakdown interface.
 */
export function instanceOfPortfolioEarningsBreakdown(value: object): value is PortfolioEarningsBreakdown {
    return true;
}

export function PortfolioEarningsBreakdownFromJSON(json: any): PortfolioEarningsBreakdown {
    return PortfolioEarningsBreakdownFromJSONTyped(json, false);
}

export function PortfolioEarningsBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioEarningsBreakdown {
    if (json == null) {
        return json;
    }
    return {
        
        'loyaltyPointsEarned': json['loyalty_points_earned'] == null ? undefined : json['loyalty_points_earned'],
        'loyaltyPointsCashValue': json['loyalty_points_cash_value'] == null ? undefined : json['loyalty_points_cash_value'],
        'gondolaCashEarned': json['gondola_cash_earned'] == null ? undefined : json['gondola_cash_earned'],
        'creditCardPointsEarned': json['credit_card_points_earned'] == null ? undefined : json['credit_card_points_earned'],
        'creditCardName': json['credit_card_name'] == null ? undefined : json['credit_card_name'],
        'totalEarningsUsd': json['total_earnings_usd'] == null ? undefined : json['total_earnings_usd'],
    };
}

export function PortfolioEarningsBreakdownToJSON(json: any): PortfolioEarningsBreakdown {
    return PortfolioEarningsBreakdownToJSONTyped(json, false);
}

export function PortfolioEarningsBreakdownToJSONTyped(value?: PortfolioEarningsBreakdown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loyalty_points_earned': value['loyaltyPointsEarned'],
        'loyalty_points_cash_value': value['loyaltyPointsCashValue'],
        'gondola_cash_earned': value['gondolaCashEarned'],
        'credit_card_points_earned': value['creditCardPointsEarned'],
        'credit_card_name': value['creditCardName'],
        'total_earnings_usd': value['totalEarningsUsd'],
    };
}

